import { Divider, Group, Stack, Text } from "@mantine/core";


type Props = {
    summary: {
        totalPrice: number;
        totalCommission: number;
        totalProviderShare: number;
    };
    // An applied discount code: shown as its own line and taken off what the customer pays.
    discount?: { code: string | null; amount: number };
};

export default function PriceSummary({ summary, discount }: Props) {
    const discountAmount = discount?.amount ?? 0;

    return (

        <Stack gap="xs">
            <Group justify="space-between">
                <Text size="sm">مجموع قیمت</Text>
                <Text size="sm">{summary.totalPrice.toLocaleString()} ریال</Text>
            </Group>
            <Group justify="space-between">
                <Text size="sm">سهم تیم</Text>
                <Text size="sm">{summary.totalProviderShare.toLocaleString()} ریال</Text>
            </Group>

            <Group justify="space-between">
                <Text size="sm">سهم مجموعه (کمیسیون)</Text>
                <Text size="sm">{summary.totalCommission.toLocaleString()} ریال</Text>
            </Group>

            {discountAmount > 0 && (
                <Group justify="space-between">
                    <Text size="sm" c="green.8">تخفیف{discount?.code && <> (<span dir="ltr" style={{ fontFamily: "ui-monospace, SFMono-Regular, Menlo, Consolas, monospace" }}>{discount.code}</span>)</>}</Text>
                    <Text size="sm" c="green.8">−{discountAmount.toLocaleString()} ریال</Text>
                </Group>
            )}

            <Divider my="xs" />

            <Group justify="space-between">
                <Text fw={700}>پرداخت مشتری</Text>
                <Text fw={700}>
                    {Math.max(0, summary.totalPrice - discountAmount).toLocaleString()} ریال
                </Text>
            </Group>
        </Stack>

    );
}